import React from "react";
import loadable from "@loadable/component";
import APIS from "../../contants/Endpoints";
import usePostHook from "../../customHooks/usePostHook";
import { useForm } from "react-hook-form";
import { categoryFormValidation } from "../../utils/formValidation";
import { yupResolver } from "@hookform/resolvers/yup";
const AddCategoryComponent = loadable(
  () => import("../../components/Category/AddCategory")
);

type Props = {};

type FormValues = {
  name: string;
  code: string;
};

const AddCategory: React.FC<Props> = (props) => {
  const { isPostLoading, mutateAsync } = usePostHook({
    queryKey: ["category"],
    navigateURL: "/category",
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(categoryFormValidation),
    defaultValues: {
      name: "",
      code: "",
    },
  });

  const handleCreateCategory = async (values: FormValues) => {
    const url = APIS.CATEGORY;
    const formData = {
      name: values.name,
      code: values.code,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error("Error creating category:", err);
    }
  };

  return (
    <>
      <AddCategoryComponent
        handleCreateCategory={handleCreateCategory}
        isPostLoading={isPostLoading}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
      />
    </>
  );
};

export default AddCategory;
